import API_BASE_URL from "../RestAPI";

const BASE = `${API_BASE_URL.replace(/\/$/, "")}/reports`;

const getAuthHeaders = () => {
    const token = localStorage.getItem("authToken");
    const headers = { "Content-Type": "application/json" };
    if (token) headers.Authorization = `Bearer ${token}`;
    return headers;
};

const buildQuery = (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([key, val]) => {
        if (val == null || val === "") return;
        if (Array.isArray(val)) {
            const list = val.filter((v) => v != null && v !== "");
            if (list.length) qs.append(key, list.join(","));
        } else {
            qs.append(key, String(val));
        }
    });
    const s = qs.toString();
    return s ? `?${s}` : "";
};

const handle = async (res, fallbackMsg) => {
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status === "fail") {
        throw new Error(data.message || res.statusText || fallbackMsg);
    }
    return data;
};

export const whatIveDoneApi = {
    // Optional params: { range: 'today'|'week', from_date, to_date, sprint_ids: [] }
    getMyWork: async (params = {}) => {
        const res = await fetch(`${BASE}/my/work/${buildQuery(params)}`, {
            method: "GET",
            headers: getAuthHeaders(),
        });
        return handle(res, "Failed to fetch your work");
    },
};

export default whatIveDoneApi;
